module.exports = __webpack_public_path__ + "img/logo.df107197.png";